@if (order$ | async; as order) {
<div class="saved-cart-details-header">
  <div class="saved-cart-details-title">
    <h1>{{ 'cart.savedCart.details.headerTitle' | cxTranslate }}</h1>
  </div>
  <div class="saved-cart-details-export">
    <app-cart-export [cartId]="cartId"></app-cart-export>
  </div>
</div>
<div class="saved-cart-item-list-wrapper">
  @for (item of order?.savedCartData?.entries; track item; let i = $index) {
  <div class="saved-cart-item-list-row">
    <div class="scd-details">
      <div class="scd-prod-details">
        <div class="scd-image">
          @if (item?.product?.images) {
          <cx-media
            [container]="getImageRendition((item?.product?.images)[0])"
            format="product"
            [class.is-missing-fish]="businessType === 'fish'"
            removeImageTitleAttr
          ></cx-media>
          } @else {
          <cx-media
            class="cx-no-image is-missing"
            [class.is-missing-fish]="businessType === 'fish'"
            removeImageTitleAttr
          ></cx-media>
          }
        </div>
        <div class="scd-desc">
          <!-- Item sku -->
          <div class="scd-sku">
            <span class="sku"> {{ item?.product?.code }} </span>
            @if (item?.product?.manualAllocation && manualAllocationEnabled) {
            <span class="no-stock">
              {{ 'product.noStock' | cxTranslate }}
            </span>
            } @else { @switch ((item?.product)['inStockFlag']) { @case (true) {
            <span class="in-stock">
              {{ 'product.inStock' | cxTranslate }}
            </span>
            } @case (false) { @if (!isDiscontinued(item?.product.stock.stockLevelStatus)) {
            <span class="no-stock">
              {{ 'product.noStock' | cxTranslate }}
            </span>
            } @else {
            <span class="discontinued">
              {{ 'product.discontinued' | cxTranslate }}
            </span>
            } } } }
          </div>
          <!-- Item name -->
          <div class="scd-name" [innerHTML]="item?.product?.name"></div>
          <!-- Item color -->
          <div class="scd-color">
            @if (item?.product?.superCategories) {
            <div class="global-variant">
              @for ( variant of checkVariant(item?.product?.superCategories); track variant; let index = $index; let
              last = $last) { @if (!last) {
              {{ variant.parentCategoryName }}: {{ variant.name }}; } @else { {{ variant.parentCategoryName }}:
              {{ variant.name }}
              } }
              <!-- In ticket GB2B-26444, this is to display JAN code on the Japan site only -->
              @if (janCodeEnabled) {
              <div class="jan-code">
                <div class="label">
                  {{ 'cart.cartItem.jan' | cxTranslate }}
                  @if (item.product?.jan || item.product?.ean) {
                  <span class="attr-value">
                    {{ item.product?.jan || item.product?.ean }}
                  </span>
                  }
                </div>
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>
      <div class="scd-prod-prices">
        <!-- Item srp - in ticket GB2B-4539, this should not display, hide it just incase they need to show this again-->
        <div class="scd-srp">
          <div class="label">{{ 'cart.savedCart.details.srp' | cxTranslate }}</div>
          <div class="value">{{ item?.product?.srpPrice?.formattedValue }}</div>
        </div>
        <!-- Item base price - in ticket GB2B-4539, this should not display, hide it just incase they need to show this again -->
        <div class="scd-base-price">
          @if (!showSrp) {
          <div class="label">{{ 'cart.savedCart.details.basePrice' | cxTranslate }}</div>
          } @if (!showSrp) {
          <div class="value">{{ item?.product?.basePrice?.formattedValue }}</div>
          }
        </div>
        <!-- Item dealer price -->
        <div class="scd-dealer-price">
          <div class="label">{{ 'cart.savedCart.details.dealerPrice' | cxTranslate }}</div>
          @if (!showSrp) {
          <div
            class="value"
            [ngClass]="{
              'promo-version':
                (item?.product?.potentialPromotions && item?.product?.potentialPromotions.length > 0) ||
                (item?.promotionMessage && item?.promotionMessage !== '')
            }"
          >
            @if (!dealerPrice(item?.product?.code)) {
            <div class="spinner-shimano-wrapper-dp">
              @if (tooltipIconConfig$ | async; as tooltipIconConfig) { @if (hasDealerPrice) {
              <div class="spinner-shimano">
                <div class="spinner-shimano-mt-ml"></div>
              </div>
              } @if (!hasDealerPrice && !tooltipIconConfig?.enabled) {
              <div class="no-dealer-price no-dealer-price-cs-cm"></div>
              } @else { @if (!hasDealerPrice && tooltipIconConfig?.enabled) {
              <app-tooltip-icon
                [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                dealerPriceIconContainerClass="no-dealer-price-cs-cm"
                placement="bottom-right"
                [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
              ></app-tooltip-icon>
              } } }
            </div>
            } @else { @if (item.updateable && item.totalPrice.value > 0) {
            {{ item.basePrice?.formattedValue }}
            @if (item.basePrice?.formattedValue && showGstExclusive$ | async) {
            <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
            }
            <app-erp-promotional-text [product]="item"></app-erp-promotional-text>
            } @else {
            {{ item.totalPrice.formattedValue }}
            @if (item.totalPrice.formattedValue && showGstExclusive$ | async) {
            <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
            }
            <app-erp-promotional-text [product]="item"></app-erp-promotional-text>
            } }
          </div>
          }
        </div>
        <!-- Item qty -->
        <div class="scd-qty">
          <input disabled value="{{ item?.quantity }}" type="number" min="1" max="999" step="1" />
        </div>
        <!-- Item total -->
        <div class="scd-total">
          <div class="label">{{ 'cart.savedCart.details.total' | cxTranslate }}</div>
          @if (!showSrp) {
          <div class="value">
            {{ item?.totalPrice?.formattedValue }}
            @if (item?.totalPrice?.formattedValue && showGstExclusive$ | async) {
            <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
            }
          </div>
          }
        </div>
      </div>
    </div>
    @if (shimanoMemoEnabled) {
    <div class="scd-memo-entry">
      <div class="scd-memo">
        <mat-form-field appearance="outline">
          <input
            readonly
            matInput
            value="{{ item?.memo }}"
            placeholder=""
            class="memoInput"
            #tooltip="matTooltip"
            (mouseover)="showMemoTooltip($event, tooltip)"
            (click)="showMemoTooltip($event, tooltip, 2000)"
            matTooltip="{{ memoIsTruncated ? item?.memo : null }}"
            matTooltipClass="memo-tooltip"
            matTooltipPosition="below"
          />
        </mat-form-field>
      </div>
    </div>
    }
    <!-- Item lead time + Promotional text -->
    <div
      class="scd-footer"
      [class.no-lead-time]="
        !item?.product?.leadTime ||
        !item?.product?.dateLeadTime ||
        !item?.product?.monthLeadTime ||
        !(item.product?.stock.stockLevelStatus === 'inStock' || item.product?.stock.stockLevelStatus === 'backorder')
      "
    >
      @if ( (item?.product?.leadTime && item?.product?.dateLeadTime && item?.product?.monthLeadTime) ||
      item.product?.stock.stockLevelStatus === 'inStock' || item.product?.stock.stockLevelStatus === 'backorder' ) {
      <div class="scd-lead-time">
        @if (showWarehouseFeature$ | async) { @if ( item.product?.stock.stockLevelStatus === 'backorder' &&
        item.product?.stock.stockLevel === 0 && item.product?.monthLeadTime ) {
        <div class="label">{{ 'cart.cartItem.dateLeadTime.title' | cxTranslate }}</div>
        <div class="value">{{ item.product?.monthLeadTime }}</div>
        } } @else { @if (item.product?.leadTime) { @if ( item.product?.stock.stockLevelStatus === 'inStock' ||
        item.product?.stock.stockLevelStatus === 'backorder' ) {
        <div class="label">
          {{ 'cart.cartItem.leadtime.title' | cxTranslate }}
        </div>
        } @if (item.product?.stock.stockLevelStatus === 'inStock') {
        <div class="value">
          {{ 'cart.cartItem.leadtime.value.instock' | cxTranslate : { time: item.product?.leadTime } }}
          {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
        </div>
        } @if (item.product?.stock.stockLevelStatus === 'backorder') {
        <div class="value">
          {{ 'cart.cartItem.leadtime.value.backorder' | cxTranslate : { time: item.product?.leadTime } }}
          {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
        </div>
        } } }
      </div>
      } @if (!showSrp) {
      <app-promotional-text
        [product]="item?.product"
        [cartItem]="item"
        [orderEntryNumber]="item.entryNumber"
        [appliedProductPromotions]="order?.savedCartData?.appliedProductPromotions"
        [promotionLocation]="'SAVEDCARTDETAILS'"
      ></app-promotional-text>
      }
    </div>
  </div>
  }
  <app-cart-export class="mobile-cart-export" [cartId]="cartId"></app-cart-export>
</div>
}
